import axios from 'axios';
import account from '@/api/v1/account';
// URL and endpoint constants
// Messages
const INDEX_URL = '/messages'; // GET, POST
const REMINDER_URL = '/messages/reminder'; // POST
const POLL_URL = '/messages/poll'; // POST
const PINBOARD_ID = account.user.pinboard;
const CHILDCODE = account.user.child;
const BANNER_URL = '/banner'; // GET
const BANNER_READ_URL = '/banner/read'; // POST
const EXPORT_PDF_MESSAGE_URL = '/pdf/msg'; // GET
const EXPORT_PDF_LETTER_URL = '/pdf/letter';

const translateTarget = () => JSON.parse(localStorage.getItem('translateTarget'));

export default {
  translateTarget,
  // GET
  index(succ, params) {
    // eslint-disable-next-line
    params.pinboard = params.pinboard || PINBOARD_ID;
    // eslint-disable-next-line
    params.childcode = params.childcode || CHILDCODE;

    var time= Math.floor(Date.now() / 1000);
    params['time']=time;
    axios.get(INDEX_URL, { params }).then((response) => {
      succ(response.data);
    });
  },
  show(succ, messageId) {
    const params = account.user.parent ? { code: CHILDCODE } : {};
    var time= Math.floor(Date.now() / 1000);
    params['time']=time;
    axios.get(`${INDEX_URL}/${messageId}`, { params }).then((response) => {
      succ(response.data);
    });
  },
  // PUT
  // Sets a message to open or closed
  changeStatus(params, messageId) {
    // eslint-disable-next-line
    if (account.user.parent) params.code = CHILDCODE;

    return axios.put(`${INDEX_URL}/${messageId}`, {}, { params });
  },
  // PUT
  // Open reply
  openReply(messageId) {
    return axios.put(`${INDEX_URL}/open_reply/${messageId}`);
  },
  // POST
  new(data, file, originalMessage) {
    const params = { pinboard: PINBOARD_ID, isweb: true };
    if (account.user.parent) params.code = CHILDCODE;
    if (originalMessage) params.original_message = originalMessage;

    const formData = new FormData();
    formData.append('content', JSON.stringify(data));
    if (file) formData.append('file', file);

    return axios.post(INDEX_URL, formData, {
      params,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  savePollChoices(params, messageId) {
    // eslint-disable-next-line
    if (account.user.parent) params.code = CHILDCODE;
    return axios.post(`${POLL_URL}/${messageId}`, {}, { params });
  },
  sendReminder(messageId) {
    return axios.post(`${REMINDER_URL}/${messageId}`, {}, { params: { isweb: true } });
  },
  translate(source, target, message, succ) {
    let url = `https://translation.googleapis.com/language/translate/v2?key=${process.env.GOOGLE_API_KEY}`;
    url += `&source=${source}`;
    url += `&target=${target}`;
    url += `&q=${message}`;
    fetch(url).then(response => response.json())
    .then((data) => {
      succ(data.data.translations[0].translatedText);
    });
  },
  getLanguages(succ) {
    const url = `https://translation.googleapis.com/language/translate/v2/languages?key=${process.env.GOOGLE_API_KEY}`;
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ target: 'EN' }),
    }).then(response => response.json())
    .then((data) => {
      succ(data.data.languages);
    });
  },
  getBanner(succ) {
    return axios.get(`${BANNER_URL}`, {}, { params: { isweb: true } }).then((response) => {
      succ(response.data);
    });
  },
  readBanner(succ, params) {
    return axios.post(`${BANNER_READ_URL}`, {}, { params }).then((response) => {
      succ(response.data);
    });
  },
  exportPdfMessage(succ, params) {
    params['code'] = CHILDCODE;
    return axios.get(`${EXPORT_PDF_MESSAGE_URL}`,{
        params: params,
        headers: { 'Content-Type': 'application/pdf' },
        responseType: 'blob',
      }
    ).then((response) => {
      this.downloadMessagesPdf(response.data, params.messageid);
      succ(response.data);
    });
  },
  exportPdfLetter(succ, params) {
    return axios.get(`${EXPORT_PDF_LETTER_URL}`,{
      params: params,
      headers: { 'Content-Type': 'application/pdf' },
      responseType: 'blob',
    }).then((response) => {
      this.downloadMessagesPdf(response.data, params.messageid);
      succ(response.data);
    });
  },
  downloadMessagesPdf(data, messageId) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data, 'message_' + messageId + '.pdf');
      return;
    }
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = window.URL.createObjectURL(data);
    link.download = 'message_' + messageId + '.pdf';
    link.click();
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/messages.js